import { icons } from "assets";
import ActionCard from "Components/shared/cards/ActionCard";
import { DebitCard } from "Components/shared/cards/DebitCard";
import WalletCard from "Components/shared/cards/WalletCard";
import Loader from "Components/shared/loaders/OverlayLoader";
import React, { startTransition, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetUsersDebitCard } from "services/debitCardService";
import { Storage } from "utils/clientStorage";
import styles from "./debit.module.css";

export const DebitCardHomeHeader = () => {
  const navigate = useNavigate();

  const {
    status: usersCardDetailsStatus,
    error: usersCardDetailsError,
    data: usersCardDetailsData,
  } = useGetUsersDebitCard();

  let data = usersCardDetailsData?.data.card;

  useEffect(() => {
    Storage.setItem("DOLLAR", data?.balance);
    Storage.setItem("CARDNUMBER", data?.cardNumber);
    Storage.setItem("DEBITCARD", data?.cardNumber);
  }, [data]);

  console.log("DEBIT CARD ", usersCardDetailsData?.data.card);

  if (usersCardDetailsData) {
    return (
      <div className={styles.debitHead}>
        <WalletCard
          style={{ height: 175, flexBasis: 350 }}
          balance
          background="#FFFFFF"
          symbol="naira"
          amount={data.balance}
          onRefresh={(cb) => setTimeout(() => cb(), 4000)}
        />
        <DebitCard
          info
          classname
          cardNumber={data.cardNumber}
          expiryDate={data.exp}
          // background="#CBD5E1"
          background="linear-gradient(305.01deg, #0169FF -35.6%, #20BF6B 65.87%)"
          style={{ height: 175, flexBasis: 300 }}
          cardId={data.cardId}
        />
        <ActionCard
          icon={icons.addColor}
          variant="primary"
          title="Add Fund to card"
          clickable
          subtitle="Add fund into your debit card."
          onClick={() => startTransition(() => navigate("fund-card"))}
          sty={{ height: 225, flexBasis: 300 }}
          amount={data.balance}
        />
      </div>
    );
  } else {
    return <Loader />;
  }
};
